import React from "react";
import { MdOutlineBarChart } from "react-icons/md";
import { useNavigate } from "react-router-dom";
const DashbordCard = ({ card, iconClass }) => {
  let navigate = useNavigate();

  const handleCardClick = (NavigationPath) => {
    navigate(NavigationPath);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {card &&
        card.map((items, i) => {
          console.log(items?.path, "items?.path");
          return (
            <div
              key={i}
              className={`flex flex-col flex-wrap xl:flex-row items-center ${
                items.title === "KYC Status" ? "" : "lg:border-r-[1px]"
              } border-[#DAE3F8] w-full  lg:w-[320px] xl:w-[385px]  h-auto py-4 px-6 md:px-12 gap-2 cursor-pointer`}
              onClick={() => handleCardClick(items?.path)}
            >
              <div className="flex justify-center items-center  w-full md:w-auto mb-4 md:mb-0 md:mr-4 ">
                <div
                  className={`${iconClass} flex justify-center items-center w-16 h-16 p-4  `}
                  style={{ backgroundColor: items.iconContainer || "#FFE9E6" }}
                >
                  <img src={`${items.icon}`} alt="icon" />
                </div>
              </div>
              <div className="flex-grow px-0 md:px-4 text-center md:text-left">
                <div className="text-[#92959E] pb-2">{`${items.title}`}</div>
                <div>{`${items.content}`}</div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default DashbordCard;
